import MaintenanceWorkflowForwardingCheckinEntrySection from "../../../sections/CheckinEntry";
import MaintenanceWorkflowForwardingDirectiveEntryExecutionEntry from "../../../sections/DirectiveEntry/entries/ExecutionEntry";

const ExecutionEntryOnGoingCheckin = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingCheckinEntrySection
        showTransportAutoEntriesDeliveryCodeWithComplete
      />

      <MaintenanceWorkflowForwardingDirectiveEntryExecutionEntry />
    </>
  );
}

export default ExecutionEntryOnGoingCheckin;
